import { GameManager } from '@lc/interface/gameManager/types';
import { GameState } from '@lc/interface/gameState/types';
import { Payment } from '@lc/interface/payment/types';

import { getPlayerStateWithId } from './player_helper';

export function createBotPlayerData(gameManager: GameManager) {
	const { gameState } = gameManager;

	return {
		playerId: gameState.activePlayerId,
		gameId: gameState.game_id_server,
	};
}

export function createBotPlayerPaymentData(
	gameManager: GameManager,
	paymentObject: Payment
) {
	const { gameState } = gameManager;

	return {
		playerId: gameState.activePlayerId,
		gameId: gameState.game_id_server,
		paymentObject,
	};
}

// calculate this before and after running an AI turn test fuction
// SCORE
// get battery +50
// get factory +250
// get energy (energy delta?) + 100
// play card (todo split by type) + 10
// win/lose contract/award score += 100
// get carbon, score += numCarbon * 10
// get PR, score += numPR * 10
// win game, score += 1000
// win game with highest donation, 10000

function getPlayerHeuristicScore(aiState: any, weights: any) {
	let score = 0;
	// player state
	score += aiState.factories * weights.f1;
	score += aiState.batteries * weights.b1;

	score += aiState.factoryEnergyArr.length * weights.f2;
	score += aiState.batteryEnergyArr.length * weights.b2;

	score += aiState.carbonReserve * weights.cR;
	score += aiState.carbonFootprint * weights.cF;

	score += aiState.prArr.length * weights.pr;

	score += aiState.donationCupArr.length * weights.dc;

	score += aiState.seasonalCards.length * weights.seaC; // lil encouragement to play cards
	score += aiState.summitCards.length * weights.sumC; // lil encouragement to play cards

	score += aiState.activeContractsAndAwards.length * weights.aCA;
	score += aiState.completedContractsAndAwards.length * weights.cCA;
	score += aiState.completedAwards.length * weights.cA;
	score += aiState.completedContracts.length * weights.cC;

	return score;
}

export function heuristicScore(gameState: GameState, weights: any): number {
	const activePlayerId = gameState.activePlayerId;
	console.log('ai id: ' + activePlayerId);
	const aiState = getPlayerStateWithId(
		gameState.playerStateArray,
		activePlayerId
	);

	let score = 0;
	const seasonScore = 2500;
	const winScore = 25000;
	const winDonoScore = 1000000;

	score += getPlayerHeuristicScore(aiState, weights);
	score += seasonScore * gameState.seasonTracker;

	// game state
	if (gameState.gameStatus === 1) {
		score -= winScore;
	} else if (gameState.gameStatus === 2) {
		score += winScore;
	}

	// player who donated the most
	let highestDonator = '';
	let highestDonation = 0;
	for (const [key, value] of Object.entries(gameState.worldEnergy)) {
		console.log(`${key}: ${value}`);
		if ((value as number) > highestDonation) {
			highestDonation = value as number;
			highestDonator = key;
		}
	}

	if (aiState.color === highestDonator) {
		score += winDonoScore;
	}

	return score;
}

export function heuristicScoreTotal(
	gameState: GameState,
	weights: any
): number {
	const players = gameState.playerStateArray;
	const activePlayerId = gameState.activePlayerId;
	console.log('ai id: ' + activePlayerId);
	const aiState = getPlayerStateWithId(
		gameState.playerStateArray,
		activePlayerId
	);

	const seasonScore = 2500;
	const winScore = 25000;
	const winDonoScore = 1000000;
	let totalScore = 0;

	for (let i = 0; i < players.length; i++) {
		totalScore += getPlayerHeuristicScore(players[i], weights);
	}

	totalScore += seasonScore * gameState.seasonTracker;

	// game state
	if (gameState.gameStatus === 1) {
		totalScore -= winScore;
	} else if (gameState.gameStatus === 2) {
		totalScore += winScore;
	}

	// player who donated the most
	let highestDonator = '';
	let highestDonation = 0;
	for (const [key, value] of Object.entries(gameState.worldEnergy)) {
		console.log(`${key}: ${value}`);
		if (value > highestDonation) {
			highestDonation = value;
			highestDonator = key;
		}
	}

	if (aiState.color === highestDonator) {
		totalScore += winDonoScore;
	}

	return totalScore;
}

export function softmaxPick(
	scores: number[],
	currentScore: number,
	temperature = 1.0
) {
	// Convert to improvements
	const deltas = scores.map((s) => s - currentScore);

	// Compress score range
	const scaled = deltas.map((d) => d / 10);

	const maxScore = Math.max(...scaled);

	const expScores = scaled.map((score) =>
		Math.exp((score - maxScore) / temperature)
	);

	const sumExp = expScores.reduce((a, b) => a + b, 0);

	const probabilities = expScores.map((score) => score / sumExp);

	const r = Math.random();

	let cumulative = 0;

	for (let i = 0; i < probabilities.length; i++) {
		cumulative += probabilities[i];

		if (r <= cumulative) {
			return i;
		}
	}

	return probabilities.length - 1;
}
